function DashboardPanel(id) {
  this.panel = $('#' + id);
  this.link = $('#show_' + id + '_link');
  this.params_for_request = false;
}

DashboardPanel.prototype.listenForShow = function () {
  var _this = this;

  _this.link.on('click', function (e) {
    e.preventDefault();
    var options = {
      url: $(this).attr('href'),
      dataType: 'html'
    };

    if (typeof _this.pramsForRequest === 'function') {
      options.data = _this.pramsForRequest();
    }

    $.ajax(options).done(function (data) {
      _this.panel.html($(data));
    });
  });

  return this;
};

export { DashboardPanel };